var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "@babel/runtime-corejs2/helpers/defineProperty", "react", "prop-types", "../../UI/Button/Button", "./SearchDurationFilter.css"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("react"), require("prop-types"), require("../../UI/Button/Button"), require("./SearchDurationFilter.css"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.defineProperty, global.react, global.propTypes, global.Button, global.SearchDurationFilter);
    global.SearchDurationFilter = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _defineProperty2, _react, _propTypes, _Button, _SearchDurationFilter) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _Button = _interopRequireDefault(_Button);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var SearchDurationFilter = /*#__PURE__*/function (_PureComponent) {
    (0, _inherits2.default)(SearchDurationFilter, _PureComponent);

    var _super = _createSuper(SearchDurationFilter);

    function SearchDurationFilter() {
      var _this;

      (0, _classCallCheck2.default)(this, SearchDurationFilter);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleButtonClick", function (event, step) {
        if (_this.props.onButtonClick) {
          var value = _this.props.sliderStepKeys.indexOf(step);

          var filter = {
            key: step,
            label: _this.props.labels[step],
            value: value
          };

          _this.props.onButtonClick(event, filter);
        }
      });
      return _this;
    }

    (0, _createClass2.default)(SearchDurationFilter, [{
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props = this.props,
            ariaButtonPrefixId = _this$props.ariaButtonPrefixId,
            ariaLabelledBy = _this$props.ariaLabelledBy,
            labels = _this$props.labels,
            sliderStepKeys = _this$props.sliderStepKeys,
            buttonType = _this$props.buttonType;
        return /*#__PURE__*/_react.default.createElement(_SearchDurationFilter.StyledSearchDurationFilter, null, sliderStepKeys.map(function (step, index) {
          return /*#__PURE__*/_react.default.createElement(_SearchDurationFilter.StyledDurationButton, {
            key: step
          }, /*#__PURE__*/_react.default.createElement(_Button.default, {
            id: "".concat(ariaButtonPrefixId).concat(index),
            ariaLabelledBy: "".concat(ariaLabelledBy, " ").concat(ariaButtonPrefixId).concat(index),
            label: labels[step],
            onClick: function onClick(event) {
              return _this2.handleButtonClick(event, step);
            },
            type: buttonType
          }));
        }));
      }
    }]);
    return SearchDurationFilter;
  }(_react.PureComponent);

  SearchDurationFilter.propTypes = {
    ariaButtonPrefixId: _propTypes.default.string,
    ariaLabelledBy: _propTypes.default.string,
    buttonType: _propTypes.default.string,
    labels: _propTypes.default.shape().isRequired,
    onButtonClick: _propTypes.default.func,
    sliderStepKeys: _propTypes.default.arrayOf(_propTypes.default.string).isRequired
  };
  SearchDurationFilter.defaultProps = {
    ariaButtonPrefixId: 'search-button-',
    buttonType: 'button',
    labels: {
      '5m': '5 minutes',
      '15m': '15 minutes',
      '60m': '60 minutes',
      alot: 'Beaucoup'
    },
    onButtonClick: function onButtonClick() {},
    sliderStepKeys: ['5m', '15m', '60m', 'alot']
  };
  var _default = SearchDurationFilter;
  _exports.default = _default;
});